<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Feriado" resource="feriados" primaryKey="idferiado" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import FeriadoService from "@/services/feriado.service";
import { feriado } from "@/models/feriado";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: feriado,
      service: FeriadoService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        FeriadoService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
